import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "reports-wr-reports"
}
const _hoisted_3 = { class: "reports-header" }
const _hoisted_4 = { class: "subtitle-main" }
const _hoisted_5 = { class: "reports-container" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "title-estate" }
const _hoisted_8 = { class: "image-wr-estate" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "title-main" }, "Reports", -1)),
          _createElementVNode("h3", _hoisted_4, "The time is " + _toDisplayString($setup.clock), 1)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "reports-title-select" }, [
          _createElementVNode("h2", { class: "title-main" }, "Select an Estate to View its Graphs")
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          ($setup.estates.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.estates, (estate, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "card-column",
                  key: estate.title
                }, [
                  _createElementVNode("div", {
                    class: "card-estate",
                    onClick: ($event: any) => ($setup.goToEstateGraph(estate))
                  }, [
                    _createElementVNode("h2", _hoisted_7, _toDisplayString(estate.title), 1),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        class: "image-estate",
                        src: estate.logoUrl
                      }, null, 8, _hoisted_9)
                    ])
                  ], 8, _hoisted_6)
                ]))
              }), 128))
            : _createCommentVNode("", true)
        ])
      ]))
}